<template>
  <div class="table-crud-modal" ref="modal">
    <h2 class="lvl2-heading">Modifier le slider</h2>
    <el-form
      :model="params"
      label-position="left"
      :status-icon="true"
      ref="editSliderForm"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form-item prop="name">
            <span>Slider:</span>
            <el-input placeholder="Support" v-model="params.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="videosIds">
            <span>Videos*:</span>
            <el-select
              no-data-text="..."
              popper-class="supports-f"
              v-model="params.videosIds"
              placeholder="Videos"
              filterable
              multiple
            >
              <el-option
                v-for="vid in videos"
                :key="`vid__f-${vid.id}`"
                :label="vid.title"
                :value="vid.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="params.videosIds.length">
        <el-col :span="24">
          <el-form-item prop="videosIds">
            <span>Ordre des videos:</span>
            <draggable
              v-model="params.videosIds"
              group="video"
              class="video__table"
              @start="drag = true"
              @end="drag = false"
            >
              <transition-group>
                <div
                  v-for="videoId in params.videosIds"
                  class="video__table--item"
                  :key="videoId"
                >
                  {{
                    getVideoTitle(videoId)
                      ? getVideoTitle(videoId).title
                      : "Titre introuvable"
                  }}
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: right">
        <base-button @click.prevent.stop.native="handleSubmit" :fluid="false"
          >Modifier</base-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  Message,
  Input,
  Select,
  Option,
  Form,
  FormItem,
  Row,
  Col
} from "element-ui"
import { mapGetters } from "vuex"
import { updateSlider } from "@/api/sliders"
import { getVideos, getSponsoredVideos } from "@/api/videos"
import { emitter } from "@/utils"
import { loaderMixin } from "@/mixins"
import draggable from "vuedraggable"

export default {
  components: {
    ElInput: Input,
    ElForm: Form,
    ElFormItem: FormItem,
    ElRow: Row,
    ElCol: Col,
    ElSelect: Select,
    ElOption: Option,
    draggable
  },
  computed: {
    ...mapGetters(["modal"])
  },
  data() {
    return {
      drag: false,
      params: {
        name: "",
        videosIds: []
      },
      rules: {
        name: [
          {
            trigger: "blur",
            required: true,
            message: "Le nom est obligatoire"
          }
        ],
        videosIds: [
          {
            trigger: "blur",
            required: true,
            message: "Il faut selectionner au moins une video"
          }
        ]
      },
      videos: []
    }
  },
  mixins: [loaderMixin],

  methods: {
    getVideoTitle(id) {
      return this.videos.find(video => video.id === id)
    },
    handleSubmit() {
      this.$refs["editSliderForm"].validate(valid => {
        if (valid) {
          this.openLoader(this.$refs.modal)

          let orderedVideos = {}
          this.params.videosIds.forEach((id, index) => {
            orderedVideos[index] = {
              id,
              order: index + 1
            }
          })
          updateSlider(this.modal.payload.slider.id, {
            name: this.params.name,
            videosIds: orderedVideos
          })
            .then(() => {
              Message.success("Slider modifié")

              emitter.$emit("update-table")
              this.closeLoader()
              this.$store.dispatch("closeModal")
            })
            .catch(() => {
              /* if (
                err.reponse &&
                err.reponse.error &&
                err.response.error.message
              ) {
                Message.error(err.response)
              } else {
                Message.error("Slider n'est pas modifié.")
              } */
              this.closeLoader()
            })
        }
      })
    }
  },
  created() {
    if (this.modal.payload.sponsored) {
      getSponsoredVideos().then(res => {
        //console.log(res)
        // Should format the response to remove the extra .data
        this.videos = res.data.data
      })
    } else {
      getVideos({ all: 1 }).then(res => {
        this.videos = res.data
      })
    }

    this.params.name = this.modal.payload.slider.name
    this.params.videosIds = this.modal.payload.slider.videos.map(
      video => video.id
    )

    const { slider } = this.modal.payload
    for (const key in this.params) {
      if (slider.hasOwnProperty(key)) {
        this.params[key] = slider[key]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.video__table {
  // border: 1px solid $color-neutral-3;
  &--item {
    height: 45px;
    background-color: $color-neutral-1;
    border-top: 1px solid $color-neutral-3;
    border-right: 1px solid $color-neutral-3;
    border-left: 1px solid $color-neutral-3;
    text-align: center;
    transition: all 0.3s;
    cursor: pointer;
    &:last-of-type {
      border-bottom: 1px solid $color-neutral-3;
    }
    &:hover {
      background-color: $color-neutral-2;
    }
  }
}
</style>
